const linkExceptions = ["DUMMY","dummy","N/A","n/a","???","NA","na"];
export default linkExceptions;
